// extracted by mini-css-extract-plugin
export var centerText = "_ec-8";
export var container = "_ec-0";
export var doughnutContainer = "_ec-7";
export var legend = "_ec-a";
export var legendItemColorDisplay = "_ec-b";
export var legendItemLabel = "_ec-d";
export var legendItemValue = "_ec-c";
export var lg = "_ec-5";
export var maxWidth = "_ec-9";
export var md = "_ec-4";
export var responsive = "_ec-6";
export var sm = "_ec-3";
export var xs = "_ec-2";
export var xxs = "_ec-1";